import React, { useEffect, useRef } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../i18n/LanguageContext";
import { demoLive, insideDemo } from "../demo/demoMode";
import { LANG_MARKET } from "../lib/format";

export default function ProtectedRoute() {
  const { user } = useAuth();
  const { t, lang, setLang } = useI18n();
  const location = useLocation();

  // Identified buyer: the locale persisted at purchase (user.language) is the source of truth for the UI on load,
  // overriding IP/browser/localStorage detection. Applied once per logged-in user; manual switches still work.
  const syncedFor = useRef(null);
  useEffect(() => {
    if (!user || syncedFor.current === user.user_id) return;
    syncedFor.current = user.user_id;
    if (user.language && user.language !== lang && LANG_MARKET[user.language]) { localStorage.removeItem("mc_lang_manual"); setLang(user.language); }
  }, [lang, user, setLang]);

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-xmas-navy">
        <div className="flex flex-col items-center gap-4" data-testid="auth-loading">
          <div className="h-10 w-10 animate-spin rounded-full border-2 border-xmas-gold/30 border-t-xmas-gold" />
          <p className="font-display text-xmas-gold">{t("loading")}</p>
        </div>
      </div>
    );
  }
  // Demo isolation: any navigation to /app/* that originates inside the demo (links/navigate in reused pages) stays in the demo — for anonymous AND logged-in users.
  if (location.pathname.startsWith("/app") && demoLive() && (insideDemo() || user === false)) return <Navigate to={location.pathname.replace(/^\/app/, "/demo/app") + location.search} replace />;
  if (user === false) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  return <Outlet />;
}
